"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

require("./CalloutCard.css");

var classnames_1 = __importDefault(require("classnames"));

var Text_1 = __importDefault(require("../Text"));

function CalloutCard(_a) {
  var id = _a.id,
      Icon = _a.icon,
      appearance = _a.appearance,
      title = _a.title,
      subtitle = _a.subtitle,
      onClick = _a.onClick,
      _b = _a.skeleton,
      skeleton = _b === void 0 ? false : _b;
  var className = classnames_1.default("nimbus--callout-card", "nimbus--callout-card--" + appearance, {
    "nimbus--callout-card--skeleton": skeleton
  });
  var renderTitle = skeleton ? React.createElement(Text_1.default.Skeleton, null) : React.createElement(Text_1.default, {
    bold: true
  }, title);
  var renderSubtitle = subtitle && skeleton ? React.createElement(Text_1.default.Skeleton, {
    width: "fill"
  }) : React.createElement(Text_1.default, null, subtitle);
  var cardContent = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "nimbus--callout-card__icon",
    "aria-label": title
  }, !skeleton && React.createElement(Icon, {
    size: "medium"
  })), React.createElement("div", {
    className: "nimbus--callout-card__info"
  }, renderTitle, renderSubtitle));

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClick === null || onClick === void 0 ? void 0 : onClick(id);
  };

  return onClick ? React.createElement("button", {
    id: id,
    type: "button",
    className: className,
    onClick: handleClick
  }, cardContent) : React.createElement("div", {
    className: className
  }, cardContent);
}

exports.default = CalloutCard;